import { ReactNode } from "react"

export type HeaderBaseProps = {
  homePageLogoLink: ReactNode
}

export enum HeaderVariants {
  base,
  questionario,
  uploadDoc,
}
